(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$stickyStateProvider','$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider) {
        $stateProvider
            .state('freight-payment', {
                parent: 'app',
                url: '/freight-payment',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'ccsTrApp.freight-payment.home.title',
                    title: 'Freight Payment'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/freight-payment/freight-payment.html',
                        controller: 'FreightPaymentController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('freight-payment');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('freight-payment.all', {
                parent: 'app',
                url: '/freight-payment/all',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'ccsTrApp.freight-payment.home.title',
                    title: 'All'
                },
                views: {
                    'freight-payment-all@': {
                        templateUrl: 'app/entities/freight-payment/freight-payment.html',
                        controller: 'FreightPaymentController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('freight-payment');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('freight-payment.detail', {
                parent: 'app',
                url: '/freight-payment/{id}/detail',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'ccsTrApp.freight-payment.detail.title',
                    title: 'Detail'
                },
                views: {
                    'freight-payment-detail@': {
                        templateUrl: 'app/entities/freight-payment/freight-payment-detail.html',
                        controller: 'FreightPaymentDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('freight-payment');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', '$state', 'FreightPayment', function($stateParams, $state, FreightPayment) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return FreightPayment.get({id: paramId}).$promise;
                    }],
                    previousState: ['$state', function($state) {
                        return {
                            name: $state.current.name || 'freight-payment',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        }
                    }]
                }
            })
            .state('freight-payment.new', {
                parent: 'app',
                url: '/freight-payment/new',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI']
                },
                onEnter: ['$stateParams','$state','$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/freight-payment/freight-payment-dialog.html',
                        controller: 'FreightPaymentDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    id: null,
                                    createdOn: new Date(),
                                    createdBy: 'admin',
                                    modifiedOn: new Date(),
                                    modifiedBy: 'admin',
                                    paymentDate: null,
                                    invoiceAmount: 0,
                                    invoiceCurrency: 'USD',
                                    invoiceAmountDisplay: null,
                                    shipmentBookingNumber: null,
                                    blNumber: null,
                                    carrier: null
                                };
                            },
                            translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('freight-payment');
                                $translatePartialLoader.addPart('currencyType');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('freight-payment.all', null, {reload: 'freight-payment.all'});
                    }, function() {
                        $state.go('freight-payment.all');
                    });
                }]
            })
            .state('freight-payment.edit', {
                parent: 'app',
                url: '/freight-payment/{id}/edit',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI']
                },
                onEnter: ['$stateParams','$state','$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/freight-payment/freight-payment-dialog.html',
                        controller: 'FreightPaymentDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['FreightPayment', function(FreightPayment) {
                                return FreightPayment.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('freight-payment.all', null, {reload: 'freight-payment.all'});
                    }, function() {
                        $state.go('freight-payment.all');
                    });
                }]
            })
            .state('freight-payment.import', {
                parent: 'app',
                url: '/freight-payment/import',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.freight-payment.home.import',
                    title: 'Import'
                },
                views: {
                    'freight-payment-import@': {
                        controller: 'FreightPaymentImportDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/freight-payment/freight-payment-import-dialog.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('freight-payment');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('freight-payment.delete', {
                parent: 'app',
                url: '/freight-payment/{id}/delete',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/freight-payment/freight-payment-delete-dialog.html',
                        controller: 'FreightPaymentDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['FreightPayment', function(FreightPayment) {
                                return FreightPayment.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('freight-payment.all', null, {reload: 'freight-payment.all'});
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            $stickyStateProvider.enableDebug(true);
    }
})();
